@if(erRediger()){
  <gruppe-rediger [gruppeId]="gruppe().id" (vedLagret)="redigerFerdig()" (vedAvbryt)="redigerFerdig()" />

} @else {
  <div class="kontainer">
    <gruppe-logo [gruppe]="gruppe()" stil="xxstor"/>

    <div class="gruppeinformasjon" [ngClass]="{'malgruppe': erMalgruppe()}">
      <h1>
        @if(erMalgruppe()){
          <span class="e2e-gruppe-tittel"><span class="mal-prefix">{{'Gruppemal'|translate}}:</span> {{gruppe().gruppemal!.navn}}</span>
        } @else {
          <span class="e2e-gruppe-tittel">{{gruppe().tittel}}</span>
        }

        <button mat-icon-button [matMenuTriggerFor]="meny" (click)="$event.stopPropagation()" *kreverTilgangsrolleGruppe="'skrive'; gruppeId:gruppe().id" data-testid="gruppe-meny">
          <mat-icon class="material-symbols-fet">more_vert</mat-icon>
        </button>
        <mat-menu #meny="matMenu">
          <button mat-menu-item (click)="rediger()" >
            <mat-icon>edit</mat-icon><span>{{ 'Rediger' | translate }}</span>
          </button>
          <button mat-menu-item (click)="importerMedlemmer()">
            <mat-icon fontSet="ion-ios-people-outline" class="mat-icon--ionic-ikon"/><span>{{ 'Importer medlemmer' | translate }}</span>
          </button>
          <button mat-menu-item (click)="eksporterMoetedeltakelse()">
            <mat-icon fontSet="lederplan-ikon-excel" class="mat-icon--lederplan-ikon"/><span>{{ 'Møtedeltakelse' | translate }}</span>
          </button>
          @if(visRedigerMoetemalMenyinnslag){
          <button mat-menu-item (click)="redigerMoetemal()">
            <mat-icon>edit</mat-icon><span>{{ 'Rediger møtemal' | translate }}</span>
          </button>
          }
          <button mat-menu-item (click)="sendEpostDialog()" >
            <mat-icon>email</mat-icon><span>{{ 'Send melding til medlemmer' | translate }}</span>
          </button>
        </mat-menu>
      </h1>
      @if(erMalgruppe()){
        <p data-testid="malbeskrivelse">{{gruppe().gruppemal.beskrivelse}}</p>
        <tittel-verdi-samling stil="horisontal">
          <tittel-verdi tittel="{{'Gruppenavn'|translate}}"><verdi class="e2e-tittel">{{gruppe().tittel}}</verdi></tittel-verdi>
          <tittel-verdi tittel="{{'Møtenavn'|translate}}"><verdi class="e2e-tittel">{{gruppe().moetenavn}}</verdi></tittel-verdi>
        </tittel-verdi-samling>
      } @else {
        <p data-testid="gruppe-detaljer">{{'{moetenavn} i {grptittel} i {orgnavn}'|translate:{moetenavn: gruppe().moetenavn, grptittel: gruppe().tittel, orgnavn: gruppe().organisasjonsnavn} }} </p>
        @if(gruppe().foreldergruppenavn){
          <p>{{'Basert på malen "{navn}"'|translate:{navn:gruppe().foreldergruppenavn} }}</p>
        }
      }
      <tittel-verdi-samling stil="horisontal" class="i18nvalg" matTooltip="{{'Standard språk og tidssone benyttes i genererte PDF-rapporter og eposter'|translate}}">
        <tittel-verdi tittel="{{'Standard språk'|translate}}"><verdi><lokale [lokale]="gruppe().oppsett.spraak"/></verdi></tittel-verdi>
        <tittel-verdi tittel="{{'Standard tidssone'|translate}}"><verdi><tidssone [tidssone]="gruppe().oppsett.tidssone"/></verdi></tittel-verdi>
      </tittel-verdi-samling>

    </div>
  </div>
}
